import React, { useState, useEffect } from 'react';

// @ts-ignore
import styles from './Brands.module.scss?module';
import useViewport from '../../../Hooks/useViewport';
import { getRequest } from '../../../Helper/ApiClient';
import { INewComerWeekBrands } from '../../../../Interface/Ncw';
import { useNavigate, useParams } from 'react-router-dom';
import useNewcomerWeekHTMLConfig from '../../../Hooks/useNewcomerWeekHTMLConfig';
import BrandPagesMobile from './BrandPages/BrandPagesMobile/BrandPagesMobile';
import BrandPagesDesktop from './BrandPages/BrandPagesDesktop/BrandPagesDesktop';
import { scrollToTop } from '../Abstracts/ScrollToTopWrapper/ScrollToTopWrapper';
import { useSetAtom } from 'jotai';
import { NcwIsElementNotSwipingAtom } from '../Atoms/NcwAtoms';

export default function Brands() {
  const viewport = useViewport(1200);
  const ncwBrandsRequest = getRequest<INewComerWeekBrands[]>(
    `/api/onlineshop/newcomer-week/brands`
  );
  const ncwBrands = ncwBrandsRequest.data ?? [];

  const { bid } = useParams();
  const navigate = useNavigate();
  const [activeBrand, setActiveBrand] = useState(0);
  const [isfirstBrand, setIsFirstBrand] = useState(false);
  const [isLastBrand, setIsLastBrand] = useState(false);
  const setElementSwiping = useSetAtom(NcwIsElementNotSwipingAtom);
  useNewcomerWeekHTMLConfig(styles.NewcomerWeekHtml);

  useEffect(() => {
    if (ncwBrandsRequest.data) {
      if (!bid) {
        if (viewport == 'mobile') {
          setIsFirstBrand(true);
          let ncw_brand = ncwBrandsRequest.data && ncwBrandsRequest.data[0];
          if (ncw_brand) {
            navigate(`/newcomer-week/brands/${ncw_brand.erp_id}`);
          }
        } else if (viewport == 'desktop') {
          let ncw_brand = ncwBrandsRequest.data && ncwBrandsRequest.data[1];
          if (ncw_brand) {
            navigate(`/newcomer-week/brands/${ncw_brand.erp_id}`);
          }
        }

        return;
      }

      const index = ncwBrandsRequest.data.findIndex(
        (product) => product.erp_id === Number(bid)
      );
      if (index !== -1) {
        setActiveBrand(index);
        setIsLastBrand(index === ncwBrands.length - 1);
        setIsFirstBrand(index === 0);
      }
    }
  }, [bid, ncwBrandsRequest.data, viewport]);

  function slideToNextBrand() {
    if (ncwBrands && activeBrand < ncwBrands.length - 1) {
      const nextIndex = activeBrand + 1;
      const nextProduct = ncwBrands[nextIndex];
      scrollToTop(setElementSwiping, undefined, 'auto');
      navigate(`/newcomer-week/brands/${nextProduct.erp_id}`);
    }
  }
  function slideToPrevBrand() {
    if (activeBrand > 0 && ncwBrands) {
      const prevIndex = activeBrand - 1;
      const prevProduct = ncwBrands[prevIndex];
      scrollToTop(setElementSwiping, undefined, 'auto');
      navigate(`/newcomer-week/brands/${prevProduct.erp_id}`);
    }
  }

  return (
    <>
      {viewport == 'desktop' && (
        <BrandPagesDesktop
          slideToPrevBrand={slideToPrevBrand}
          slideToNextBrand={slideToNextBrand}
          ncwBrands={ncwBrandsRequest?.data || []}
          activeIndex={activeBrand}
          slideCount={ncwBrandsRequest?.data?.length > 2 ? 3 : 2}
        />
      )}
      {viewport == 'mobile' && (
        <BrandPagesMobile
          ncwBrands={ncwBrandsRequest?.data || []}
          activeBrand={activeBrand}
          slideToPrevBrand={slideToPrevBrand}
          slideToNextBrand={slideToNextBrand}
        />
      )}
    </>
  );
}
